module.exports = __webpack_public_path__ + "assets/images/EURUNFIT10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT10.png
// module id = 1372
// module chunks = 1